export default __webpack_public_path__ + "static/media/html.69274ea2.svg";